/*-----------------------------------------------------------------
- Schedule demo
-----------------------------------------------------------------*/
export default {
    title             : 'جدولة العرض',
    contact_us_text   : 'إذا كانت لديك أي أسئلة فورية ، فلا تتردد في الاتصال بنا على $hello@Quarkino.com$',
    interested_service: 'الخدمة المهتمة',
    select_service    : 'اختر خدمة',
    file              : 'ملف',
    demo_req_submitted: 'تم إرسال طلب العرض!',
    can_schedule      : 'يمكنك الآن جدولة العرض التوضيحي الخاص بك.',
    full_name         : 'الاسم الكامل',
    email_address     : 'عنوان البريد الإلكتروني',
    uploader_content  : 'أرفق ملف',
};
